import React, { Component } from 'react';
import { 
  Modal, 
  Button, 
  Row, 
  Col, 
  FormGroup, 
  ControlLabel, 
  FormControl, 
  Form, 
  Alert 
} from 'react-bootstrap';

class ConsolidateSellsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      quantity: '',
      price: '',
      error: ''
    };
  }

  closeModal = () => {
    this.setState({ files: [], quantity: '', price: '', error: '' });
    this.props.closeModal('showConsolidateSellsModal');
  }

  parseCSV = (fileContent) => {
    const jsonAr = [];
    const splitCSV = fileContent.split('\n');

    for (let i = 0; i < splitCSV.length; i++) {
      const splitLine = splitCSV[i]
        .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
        .map(item => {
          return item.replace(/,|"|\$/g, '');
        });

      if (splitLine[2] && splitLine[2].trim() === 'Equity') {
        jsonAr.push({
          symbol: splitLine[0],
          quantity: splitLine[3],
          accountId: splitLine[4],
          price: splitLine[8],
          marketValue: splitLine[9]
        });        
      }   
    }
    return jsonAr;
  };

  fileOnChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {

      const content = this.parseCSV(reader.result);
      const ticker = content[0].symbol || null;

      if (!ticker) return;

      this.setState({
        files: [
          ...this.state.files,
          { 
            fileName: file.name,
            fileContent: content,
            ticker: ticker
          }
        ]
      });
    }
    reader.readAsText(file);
  }

  fileListView = () => {
    const { files } = this.state;
    if (!files.length) {
      return null;
    }

    return (
      <div>
        <label style={{ marginBottom: 10 }}>Selected files:</label>

        {files.map((file, index) => {
          return (
            <FormGroup controlId={'file' + index} key={index}>
              <ControlLabel>{file.ticker}</ControlLabel>
              <FormControl
                className="submitted-sell-file"
                readOnly
                type="text"
                value={file.fileName}
              />
            </FormGroup>
          );
        })}

        <hr />
      </div>
    );
  }

  renderAlert = () => {
    if (this.state.error) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {this.state.error}
        </Alert>
      );
    }
  }

  consolidateFiles = (e) => {
    e.preventDefault();
    const { files, quantity, price } = this.state;

    if (!files.length) {
      this.setState({ error: 'Please upload at least one file.' });
      return;
    }

    const filterTickers = files.map(file => {
      return file.ticker;
    });

    const ticker = filterTickers[0] || null;
    for (let i = 0; i < filterTickers.length; i++) {
      if (ticker !== filterTickers[i]) {
        this.setState({ error: 'All files must be the same ticker.' });
        return;
      }
    }

    if (!quantity) {
      this.setState({ error: 'Please enter the amount of shares you want to sell (in percent).' });
      return;
    } else if (+quantity !== 100 && !price) {
      this.setState({ error: 'You must enter a price if all the shares are not being sold. '});
      return;
    }

    this.props.consolidateFiles({
      files: files,
      percentQty: quantity,
      price: price,
      ticker: ticker
    });
    this.fileInput.value = '';
    this.setState({ files: [], quantity: '', price: '', error: '' });
  }

  onFieldChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  
  render() {
    return (
      <Modal show={this.props.showConsolidateSellsModal} onHide={this.closeModal} className="toolbar-modal">
        <Modal.Header closeButton>
          <Modal.Title>Consolidate Files</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col mdOffset={2} md={8}> 
              <Form onSubmit={this.consolidateFiles}>        
                {this.fileListView()}

                <FormGroup controlId="quantity">
                  <ControlLabel>Quantity to Sell (%):</ControlLabel>
                  <FormControl 
                    type="number" 
                    max="100"
                    min="0"
                    step="any"
                    placeholder="e.g. 100" 
                    value={this.state.quantity} 
                    name="quantity" 
                    onChange={this.onFieldChange} />
                </FormGroup>
                <FormGroup controlId="price">
                  <ControlLabel>Sell Price:</ControlLabel>
                  <FormControl 
                    type="number" 
                    min="0"
                    step="any"
                    placeholder="e.g. 285.55" 
                    value={this.state.price} 
                    name="price" 
                    onChange={this.onFieldChange} />
                </FormGroup>
                <hr />
                {this.renderAlert()}
                <label className="btn btn-default add-file-btn full-width">
                  Add File
                  <input 
                    onChange={this.fileOnChange} 
                    type="file" 
                    accept=".csv" 
                    name="file" 
                    ref={(ref) => this.fileInput = ref}
                    style={{ display: 'none' }} 
                  />
                </label>
                <Button 
                  type="submit"
                  className="btn-blue full-width" 
                  bsStyle="primary" 
                >Consolidate</Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default"  
            onClick={this.closeModal}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ConsolidateSellsModal;